import React from 'react';
import Link from '../common/TrackedLink';
import renderHTML from 'react-render-html';

const Protection = ({ protection }) => {
	let link;

	if (protection.link) {
		link = (
			<Link to={ protection.link } className="arrow-link">
				{ renderHTML(protection.description) }
			</Link>
		);
	} else {
		link = (
			<p>{ renderHTML(protection.description) }</p>
		);
	}
	return (
		<li>
			<h4 className="protection-name">
				{ protection.name }
			</h4>
			{ protection.informationIconUrl && 
				<Link to={protection.informationIconUrl} className="icon-link">
					<span className="hide">More Information</span>
				</Link>
			}
			<img
				className="protection-icon"
				src={ protection.image }
				srcSet={ `${protection.image2x} 2x` }
				alt=""
			/>
			{ link }
		</li>
	);
};

export default Protection;


// WEBPACK FOOTER //
// ./src/pages/product/Protection.js